// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import perspective02Icon from "@/assets/icons/perspective-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Perspective02IconProps = Omit<IconProps, "name">;

export function Perspective02Icon(props: Perspective02IconProps): React.ReactNode {
  return <Icon name={perspective02Icon} {...props} />;
}
